import { render, staticRenderFns } from "./CardThumbnail.vue?vue&type=template&id=52d1daf7&scoped=true"
import script from "./CardThumbnail.vue?vue&type=script&lang=js"
export * from "./CardThumbnail.vue?vue&type=script&lang=js"
import style0 from "./CardThumbnail.vue?vue&type=style&index=0&id=52d1daf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d1daf7",
  null
  
)

export default component.exports